// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import TitleWithTooltip from "src/components/shared/text/TitleWithTooltip/TitleWithTooltip";
import ReportOrderRadio from "../../shared/ReportOrderRadio/ReportOrderRadio";

// Contexts
import { useClinicSettingsContext } from "src/contexts/clinic/ClinicSettingsContext";

const ReportOrderSetup = () => {
  const { t } = useTranslation();
  const { currentSettings, handleUpdateSettings, isLoading, isUpdating } =
    useClinicSettingsContext();

  return (
    <Box display="flex" flexDirection="column" gap="6px">
      <Box>
        <TitleWithTooltip
          title={t("Report Eye Display Order")}
          tooltip={t(
            "Controls which eye is displayed first on monocular report PDFs."
          )}
          titleStyle={{ fontSize: "14px", fontWeight: 600 }}
        />
      </Box>
      <ReportOrderRadio
        isDisabled={isLoading || isUpdating}
        currentSettings={currentSettings}
        handleUpdateSettings={handleUpdateSettings}
      />
    </Box>
  );
};

export default ReportOrderSetup;
